/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('rebuy:cart.change', (event) => { 
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          if(cart.item_count == 0){
            $(".cart__toggle").removeClass("cart__toggle--has-items");
          }
        }
    });
  });

  $('.selector-wrapper--qty .select-popout__toggle').click(function(){
    $(this).parent().find('.select-popout__list').toggleClass('select-popout__list--visible');
  });
  $('.selector-wrapper--qty .select-popout__option').click(function(){
    var v = $(this).data('value');
    $(this).parents('.select-popout').find('.select-popout__value').text(v);
    $(this).parents('.select-popout').find('[data-popout-input]').val(v);
    $(this).parents('.select-popout').find('.select-popout__list').removeClass('select-popout__list--visible');
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.read-more-wrapper').forEach(wrapper => {
      const content = wrapper.querySelector('.read-more-content');
      const toggle = wrapper.querySelector('.read-more-toggle');
      const lines = Number(wrapper.dataset.lines || 5);

      // Set up CSS variable for potential styling
      wrapper.style.setProperty('--line-clamp', lines);

      // Calculate collapsed height
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      const collapsedHeight = lineHeight * lines;

      // Hide toggle if content is not large enough
      if (content.scrollHeight <= collapsedHeight + 2) {
        toggle.style.display = 'none';
        return;
      }

      // Smoother animation: Use transition on max-height
      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 0.5s linear';
      content.style.maxHeight = collapsedHeight + 'px';
      wrapper.classList.add('is-collapsed');
      toggle.textContent = 'Read more';

      const expand = () => {
        const fullHeight = content.scrollHeight;
        content.style.maxHeight = fullHeight + 'px';
        wrapper.classList.remove('is-collapsed');
        wrapper.classList.add('is-expanded');
        toggle.textContent = 'Read less';
      };

      const collapse = () => {
        content.style.maxHeight = collapsedHeight + 'px';
        wrapper.classList.remove('is-expanded');
        wrapper.classList.add('is-collapsed');
        toggle.textContent = 'Read more';
      };

      // Handle transition when going from expanded to collapsed for smooth experience
      toggle.addEventListener('click', () => {
        if (wrapper.classList.contains('is-collapsed')) {
          expand();

          // Remove max-height after transition to allow for internal resizing
          content.addEventListener('transitionend', function handler(e) {
            if (wrapper.classList.contains('is-expanded')) {
              content.style.maxHeight = content.scrollHeight + 'px';
            }
            content.removeEventListener('transitionend', handler);
          });
        } else {
          // To ensure re-collapsing looks smooth, temporarily set max-height to full, force a reflow, then collapse
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            // Need to force a reflow to ensure the transition runs
            void content.offsetHeight;
            collapse();
          });
        }
      });

      // Optionally, handle window resize for better responsiveness
      window.addEventListener('resize', () => {
        if (wrapper.classList.contains('is-collapsed')) {
          content.style.maxHeight = collapsedHeight + 'px';
        } else if (wrapper.classList.contains('is-expanded')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
})();

$(document).ready(function(){
    $('.selector-wrapper--qty .select-popout__toggle').click(function(){
      $(this).parent().find('.select-popout__list').toggleClass('select-popout__list--visible');
    });
    $('.selector-wrapper--qty .select-popout__option').click(function(){
      var v = $(this).data('value');
      $(this).parents('.select-popout').find('.select-popout__value').text(v);
      $(this).parents('.select-popout').find('[data-popout-input]').val(v);
      $(this).parents('.select-popout').find('.select-popout__list').removeClass('select-popout__list--visible');
    });
});